import {Location} from '@angular/common';
import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Optional, Output} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';
import {ActivatedRoute} from '@angular/router';
import {NbWindowRef} from '@nebular/theme';
import {TuiPdfViewerOptions, TuiPdfViewerService} from '@taiga-ui/kit';
import {PolymorpheusContent} from '@taiga-ui/polymorpheus';
import {BaseComponent, DamItem, DamItemVersion, FileService} from 'compob2b-libs';
import {FileUploader} from 'ng2-file-upload';
import {from, Observable, Subscription} from 'rxjs';
import {catchError, concatMap, finalize, map, takeUntil, tap} from 'rxjs/operators';
import {FormConfigService} from '../../../../../../../admin-shared/services/form-config.service';
import {DamService} from '../../../../../dam.service';

interface DocumentFile {
  enabled: boolean;
  header: string;
  fileInput: File;
}

@Component({
  selector: 'app-dam-item-info-view',
  templateUrl: './dam-item-info-view.component.html',
  styleUrls: ['./dam-item-info-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DamItemInfoViewComponent extends BaseComponent implements OnInit {

  @Input() model: DamItem;
  @Input() write = false;
  @Input() damItem: DamItemVersion = null;
  @Output() change: EventEmitter<void> = new EventEmitter();

  constructor(protected readonly sanitizer: DomSanitizer,
              protected readonly pdfService: TuiPdfViewerService,
              protected readonly formConfigService: FormConfigService,
              protected readonly route: ActivatedRoute,
              protected readonly location: Location,
              @Optional() protected readonly windowRef: NbWindowRef,
              protected readonly fileService: FileService,
              protected readonly damService: DamService
  ) {
    super();
  }

  uploader: FileUploader;
  uploadURI: string;

  private subscription: Subscription;

  ngOnInit(): void {
    this.uploader = new FileUploader({
      url: null,
      disableMultipart: false,
      formatDataFunctionIsAsync: false,
      isHTML5: true,
      removeAfterUpload: false,
      autoUpload: false,
      maxFileSize: 4000 * 1024 * 1024,
    });
  }

  public upload(): void {
    if (this.uploader.queue.length) {
      this.subscription = from(this.uploader.queue)
        .pipe(
          catchError(err => this.handleError(err)),
          map(uploadingFile => uploadingFile._file),
          concatMap(uploadingFile => this.uploadFile(uploadingFile)),
          tap(response => {
            if (!response.success) {
              this.warningToast('Данный файл уже загружен раннее');
              if (response.data !== 'Entity already presented') {
                window.open('/cabinet/dam/item/edit/' + response.data, '_blank').focus();
              }
            }
          }),
          takeUntil(this.unsubscribe),
          finalize(() => this.finishUpload()),
        ).subscribe();
    }
  }

  private uploadFile(uploadingFile: File): Observable<any> {
    this.uploadURI = '/dam/upload-version/' + this.model.id;
    return this.compoApiService.postForm<DocumentFile, string>(
      this.uploadURI, {enabled: true, header: uploadingFile.name, fileInput: uploadingFile}
    );
  }

  private finishUpload(): void {
    this.uploader.clearQueue();
    this.subscription.unsubscribe();

    this.change.emit();
  }

  /**
   * @description:
   * Embedded PDFs in mobile doesn't work,
   * so you can use third-party services
   * or your own service to render PDF in mobile iframe
   */
  show(actions: PolymorpheusContent<TuiPdfViewerOptions>, id: number): void {
    this.pdfService
      .open(
        this.sanitizer.bypassSecurityTrustResourceUrl(
          this.environment.serverUrl + '/dam/data/' + this.model.syncUid + '/' + id),
        {
          label: 'Dam document',
          actions,
        },
      )
      .subscribe();
  }

}
